<template lang="html">

  <v-container grid-list-md text-xs-center fill-height>
    <v-dialog  @keydown.esc="dialog = false"
               v-model="dialog"
               fullscreen hide-overlay transition="scroll-x-transition"
    >
      <v-card v-if="selectedResult != null"
      >

        <v-card-title primary-title style="background-color: #1976d2">

          <v-flex xs1>

          </v-flex>



          <v-flex xs3 text-xs-right>
            <v-btn @click="selectAParticipant(previousParticipant)" v-if="previousParticipant != null" class="mx-2"  dark small color="primary"
            >

              <v-icon dark>navigate_before</v-icon>
              {{previousParticipant.User.firstName + ' '+ previousParticipant.User.middleName + ' ' + previousParticipant.User.lastName}}

            </v-btn>
          </v-flex>

          <v-flex text-xs-center>
            <h3 style="color: white"
                class="headline mb-0">



              {{selectedResult.User.firstName + ' '+ selectedResult.User.middleName + ' ' + selectedResult.User.lastName}}



            </h3>
          </v-flex>


          <v-flex xs3 text-xs-left>
            <v-btn @click="selectAParticipant(nextParticipant)" v-if="nextParticipant != null"  class="mx-2"  dark small color="primary"
            >
              {{nextParticipant.User.firstName + ' '+ nextParticipant.User.middleName + ' ' + nextParticipant.User.lastName}}

              <v-icon dark>navigate_next</v-icon>
            </v-btn>
          </v-flex>


          <v-flex xs1>
            <v-btn class="mx-2" fab dark small color="primary"
                   @click="dialog = false"
            >
              <v-icon dark>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>



        <v-tabs v-model="tabs"
                color="#c9ceea"
                grow

                slider-color="black"
        >
          <v-tab
                  key="1"
                  ripple
          >
            Summary

          </v-tab>


          <v-tab
                  key="2"
                  ripple
          >
            Add Payment / Fundraising

          </v-tab>

          <v-tab-item
                  key="1"
          >

            <br/>
            <v-layout row wrap >


              <v-flex xs12 style="border: 2px solid black">
                <v-subheader  style="font-weight: bold;     background: #d8d8d8;" class="participantSummarySubHeader">Participant
                  <v-btn color="secondary" small >Reset Password</v-btn>
                  <v-btn color="secondary" small >Edit Profile</v-btn>
                </v-subheader>

                <v-layout row wrap class="summaryParticipantBoxes">
                  <v-flex >
                    <span class="">{{selectedResult.User.gender}}</span>
                    <br/>
                    <strong class="bottomLabels">Gender</strong>
                  </v-flex>
                  <v-flex >
                    <span class="">07/18/1995</span>
                    <br/>
                    <strong class="bottomLabels">DOB</strong>

                  </v-flex>
                  <v-flex >
                    <span class="">{{selectedResult.Occupancy}}</span>
                    <br/>
                    <strong class="bottomLabels">Occupancy</strong>

                  </v-flex>
                  <v-flex>
                    <span class="">{{selectedResult.User.email}}</span>
                    <br/>
                    <strong class="bottomLabels">Email</strong>
                  </v-flex>
                  <v-flex>
                    <span class="">{{selectedResult.User.phone}}</span>
                    <br/>
                    <strong class="bottomLabels">Phone Number</strong>
                  </v-flex>




                </v-layout>


                <v-layout class="summaryParticipantBoxes">

                  <v-flex xs6 >
                    <span class="">allergic to peatnuts and lactose intolerant</span>
                    <br/>
                    <strong class="bottomLabels">Dietary Restrictions</strong>
                  </v-flex>

                  <v-flex xs6 >
                    <span class="">Band Choir</span>
                    <br/>
                    <strong class="bottomLabels">Group</strong>
                  </v-flex>

                </v-layout>



                <v-layout row wrap class="summaryParticipantBoxes">



                  <v-flex >
                    <span class="">${{selectedResult.selectedTripCost}}</span>
                    <br/>
                    <strong class="bottomLabels">Trip Cost</strong>
                  </v-flex>



                  <v-flex >
                    <span class="">${{selectedResult.totalFundRaised}}</span>
                    <br/>
                    <strong class="bottomLabels">Fundraising</strong>

                  </v-flex>
                  <v-flex>
                    <span class="">${{selectedResult.totalPaid}}</span>
                    <br/>
                    <strong class="bottomLabels">Payments</strong>
                  </v-flex>

                  <v-flex >
                    <span class="">${{selectedResult.nextDueAmount }}</span>
                    <br/>
                    <strong class="bottomLabels">Next Due</strong>
                  </v-flex>

                  <v-flex >
                    <span class="">{{selectedResult.nextDue | moment("MM-DD-YYYY")}}</span>
                    <br/>
                    <strong class="bottomLabels">Next Due Date</strong>
                  </v-flex>

                </v-layout>

              </v-flex>
            </v-layout>


            <br/>
            <v-divider></v-divider>
            <br/>


            <v-layout row wrap v-if="selectedResult.Fees.length > 0">


              <v-flex xs12 >


                <v-subheader style="font-weight: bold;    background: #d8d8d8;" class="participantSummarySubHeader">Overdue Payment(s)</v-subheader>

                <v-data-table class="overdueTable"  hide-actions :headers="[
              {
                text: 'Installment #',
                align: 'center',
                value: 'name',
                sortable:false
              },
              {
                  text: 'Overdue',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Unpaid',
                  sortable:false ,
                  value: 'phone'
              },
              {
                  text: 'Fee',
                  value: 'email',
                  sortable:false
              }
          ]" :items="selectedResult.Fees"
                >
                  <template slot="items" slot-scope="props">
                    <tr style="color: red" v-bind:class="{ waivedFee: props.item.Waived }" >
                      <td>{{props.item.Installment}}</td>
                      <td class="text-xs-left">{{props.item.daysOverdue + ' day(s)'}}</td>
                      <td class="text-xs-left">$200</td>
                      <td class="text-xs-left">${{props.item.Amount}}</td>

                    </tr>
                  </template>

                </v-data-table>
              </v-flex>
            </v-layout>


            <v-layout row wrap v-if="selectedResult.Payments.length > 0">


              <v-flex xs12  >

                <v-subheader style="font-weight: bold;    background: #d8d8d8;" class="participantSummarySubHeader">Payment History</v-subheader>


                <v-data-table class="paymentSummaryTable" hide-actions :headers="[

{
                text: 'Type',
                align: 'center',
                value: 'type'
              },
              {
                text: 'Billing Name',
                align: 'center',
                value: 'name'
              },
              {
                  text: 'Last 4#',
                  align: 'center',
                  value: 'endingDigits'
              },
              {
                  text: 'Amount',

                  align: 'center',
                  value: 'amount'
              },
              {
                  text: 'Date',
                  value: 'date',

                  align: 'center'
              }
          ]" :items="selectedResult.Payments"
                >
                  <template slot="items" slot-scope="props">
                    <tr >
                      <td class="text-xs-center">{{ props.item.Type  }}</td>
                      <td class="text-xs-center">{{ props.item.User.firstName + ' ' + props.item.User.lastName }}</td>
                      <td class="text-xs-center">1234</td>
                      <td class="text-xs-center">${{ props.item.Amount }}</td>
                      <td class="text-xs-center">{{ props.item.Date | moment("MM-DD-YYYY") }}</td>


                    </tr>
                  </template>

                </v-data-table>
              </v-flex>
            </v-layout>


          </v-tab-item>

          <v-tab-item
                  key="2"
          >
            <payment-form v-bind:participant="selectedResult"></payment-form>
          </v-tab-item>
        </v-tabs>

      </v-card>

    </v-dialog>

    <v-layout row wrap>
      <v-flex md12 xs12>

        <v-card elevation="5">

          <div>

            <v-card-title primary-title>

              <v-flex xs2 text-xs-center>

              </v-flex>

              <v-flex xs8 text-xs-center>
                <h3 class="headline mb-0">Trip Participants Status</h3>
                <div>List of the participants for this trip</div>
              </v-flex>

              <v-flex xs2 text-xs-center>
                <v-btn @click="exportToExcel"  color="secondary"
                ><v-icon dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>



            </v-card-title>


            <v-container  style="border-bottom: lightgray 1px solid; border-top: lightgray 1px solid; padding: 5px; padding-bottom: 5px; "  >

              <v-layout v-ripple row wrap class="tripStatBoxes">
                <v-flex xs2 @click="applyFilter('all')" v-bind:class="{ selectedFilter: filter == 'all' }" >
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Registrations</strong>

                </v-flex>
                <v-flex xs2 @click="applyFilter('fr')" v-bind:class="{ selectedFilter: filter == 'fr' }">
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.filter((participant) => participant.totalFundRaised > 0).length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Fundraisers</strong>
                </v-flex>
                <v-flex xs2 @click="applyFilter('mp')" v-bind:class="{ selectedFilter: filter == 'mp' }">
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.filter((participant) => participant.totalPaid > 0).length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Made Payment</strong>
                </v-flex>
                <v-flex xs2 @click="applyFilter('fp')" v-bind:class="{ selectedFilter: filter == 'fp' }">
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.filter((participant) => (participant.totalPaid + participant.totalFundRaised) == participant.selectedTripCost).length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Fully Paid</strong>
                </v-flex>
                <v-flex xs2 @click="applyFilter('pd')" v-bind:class="{ selectedFilter: filter == 'pd' }">
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.filter((participant) => participant.daysToDue < 3  && participant.daysToDue >= 0).length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Payment Due</strong>
                </v-flex>
                <v-flex xs2 @click="applyFilter('po')" v-bind:class="{ selectedFilter: filter == 'po' }">
                                  <span class="topTextBottomLabels">
                                      {{$structuredData.participants.filter((participant) => participant.daysToDue < 0).length}}
                                  </span>
                  <br/>
                  <strong class="bottomLabels">Payment Overdue</strong>
                </v-flex>
              </v-layout>


            </v-container>



            <v-card-actions v-if="$filterTripID != null">
              <v-layout row wrap justify-space-around >
                <v-checkbox  hide-details class="ma-0 pa-1 align-center justify-center" label="Choir" value="John"></v-checkbox>
                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Band" value="Jacob"></v-checkbox>
                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Choir + Band" value="John"></v-checkbox>
                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Bass" value="Jacob"></v-checkbox>

                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Choir + Band" value="John"></v-checkbox>
                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Bass" value="Jacob"></v-checkbox>

                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Choir + Band" value="John"></v-checkbox>
                <v-checkbox hide-details class="ma-0 pa-1 align-center justify-center" label="Bass" value="Jacob"></v-checkbox>


              </v-layout>

            </v-card-actions>

          </div>

          <div v-show="this.filter != ''" style="border-top: 2px solid black;     margin-top: 0px;">




            <v-data-table hide-actions :headers="[
              {
                text: 'Name / Email',
                align: 'left',
                value: 'User.firstName'
              },
              {
                  text: 'Phone /Gender',
                  value: 'User.phone'
              },
              {
                  text: 'Fundraising / Total Paid',
                  value: 'totalFundRaised'
              },

              {
                  text: 'Trip Cost / Next Payment',
                  value: 'selectedTripCost'
              }
          ]" :items="filteredParticipants"
            >
              <template slot="items" slot-scope="props">
                <tr style="cursor: pointer"  @click.stop="selectAParticipant(props.item)">
                  <td>{{ props.item.User.firstName + ' ' + props.item.User.lastName  }}
                    <br/>
                    {{ props.item.User.email }}
                    <br/>
                    {{ props.item.User.phone }}</td>
                  <td>{{ props.item.User.gender}}
                    <br/>
                    {{ props.item.User.phone }}</td>

                  <td>${{ props.item.totalFundRaised}}
                    <br/>
                    ${{ props.item.totalPaid }}</td>


                  <td>${{ props.item.selectedTripCost}}
                    <br/>
                    ${{ props.item.nextDueAmount}} ({{ props.item.nextDue | moment("MM-DD-YYYY")}})</td>

                </tr>

              </template>

            </v-data-table>

          </div>
        </v-card>

        <overdue-list>

        </overdue-list>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script lang="js">
    import XLSX from 'xlsx'
  export default {
      name: 'participant-status-list',
      props: ["initialAll"],
      mounted() {
          if(this.initialAll == 'true') {
              this.filter='all'
          } else {
              this.filter=''
          }
      },
      data() {
          return {
              expanded: null,
              selectedResult: null,
              dialog: false,
              filter: ''
          }
      },
      methods: {
          exportToExcel() {
              var wb = XLSX.utils.book_new();


//Vue.prototype.$userData = {"new": true}

              var ws_name = "SheetJS";

              /* make worksheet */
              var ws_data = [
                  ["Full Name", "Email", "Phone Number", "Gender", "Type", "DOB", "Occupancy", "Group", "Dietary Restrictions",
                      "Trip Cost", "Fundraising Total", "CC / Check Total", "Next Due Amount", "Next Due Date"]
              ];

              this.filteredParticipants.forEach((participant) => {
                  let row = []
                  row.push(participant.User.firstName + ' ' + participant.User.middleName + ' ' + participant.User.lastName)
                  row.push(participant.User.email)
                  row.push(participant.User.phone)
                  row.push(participant.User.gender)
                  row.push(participant.User.permissions[0])
                  row.push('07-18-1995')
                  row.push(participant.Occupancy)
                  row.push('Band')
                  row.push('lactose intolerant')
                  row.push(participant.selectedTripCost)
                  row.push(participant.totalFundRaised)
                  row.push(participant.nextDueAmount)
                  row.push(participant.totalPaid)
                  row.push(participant.nextDue)
                  ws_data.push(row)
              })


              var ws = XLSX.utils.aoa_to_sheet(ws_data);

              /* Add the worksheet to the workbook */
              XLSX.utils.book_append_sheet(wb, ws, ws_name);


              XLSX.writeFile(wb, 'out.xlsx');

          },
          selectAParticipant(participant) {
              this.dialog = true
              this.selectedResult = participant
          },
          applyFilter(filter) {
              if (this.filter != filter) {
                  this.filter = filter
              } else {
                  if (this.initialAll == 'true') {
                      this.filter = 'all'
                  }
                  else {
                      this.filter = ''
                  }
              }
              console.log('filter11111111111', this.filter)

          }
      },
      computed: {
          nextParticipant() {
              let index = this.filteredParticipants.indexOf(this.selectedResult);
              if (index + 1 >= this.filteredParticipants.length) {
                  return null
              } else {
                  return this.filteredParticipants[index + 1]
              }
          },
          previousParticipant() {
              let index = this.filteredParticipants.indexOf(this.selectedResult);
              if (index - 1 < 0) {
                  return null
              } else {
                  return this.filteredParticipants[index - 1]
              }
          },
          filteredParticipants() {
              var toReturn = []

              console.log('about to filter!', this.$structuredData.participants)
              this.$structuredData.participants.forEach((participant) => {
                  if (this.filter == 'all') {
                      toReturn.push(participant)
                  } else if (this.filter == 'fr' && participant.totalFundRaised > 0) {
                      toReturn.push(participant)
                  } else if (this.filter == 'mp' && participant.totalPaid > 0) {
                      toReturn.push(participant)
                  } else if (this.filter == 'fp' && (participant.totalPaid + participant.totalFundRaised) == participant.selectedTripCost) {
                      toReturn.push(participant)
                  } else if (this.filter == 'pd' && participant.daysToDue < 3 && participant.daysToDue >= 0) {
                      toReturn.push(participant)
                  } else if (this.filter == 'po' && participant.daysToDue < 0) {
                      toReturn.push(participant)
                  }
              })

              return toReturn

          }

      }
  }
</script>

<style scoped lang="scss">

  .selectedFilter {
    background-color: #1976d2;
    color: white;
  }
  .summaryParticipantBoxes > div.flex {
    border: 1px solid gray;
  }

  .selectedSearchResult {
    background-color: #c9ceea;
    border-bottom: 2px black solid;
    border-top: 2px black solid;
  }


  .BottomLabels {
    text-decoration: overline;
    font-size: 12px;
    position: relative;
    top: -3px;
  }

  .topTextBottomLabels {
    font-size: 35px;
  }


  .tripStatBoxes>div:hover{
    cursor: pointer;
    background-color: #1976d2e6;
    color: white;
  }
</style>
